(function() {
  'use strict';

  var grid = document.querySelector('[data-grid]');
  var buttons = document.querySelectorAll('[data-view]');

  if (!grid || !buttons.length) return;

  var saved = localStorage.getItem('cuento-grid-view');
  if (saved) {
    grid.setAttribute('data-columns', saved);
    buttons.forEach(function(btn) {
      btn.classList.toggle('is-active', btn.dataset.view === saved);
    });
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var cols = btn.dataset.view;
      grid.setAttribute('data-columns', cols);
      localStorage.setItem('cuento-grid-view', cols);
      buttons.forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
})();
